module.exports = __webpack_public_path__ + "img/help.e4aebcd9.svg";